import { MenuItem } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import { Box, InlineSpinnerIcon } from "ui-components";
import { useDebouncedValue } from "ui-lib";
import React, { useState, useMemo, useEffect } from "react";
import { useQuery, UseQueryResult } from "react-query";
import { useNavigate } from "react-router-dom";
import companySearchWithSicQuery, {
  CompanySearch,
} from "ui-io/queries/company-search-with-sic-query";
import { formatLocation } from "../routes";
import { getCompanyConfig } from "ui-io/queries/get-company-config";
import { FormDataT } from "../utils/constants";

const SelectConfig = Suggest.ofType<CompanySearch>();

type Props = {
  placeholder: string;
  sicCodes?: string[];
  setFormData?: (e: FormDataT) => void;
}

const SearchCompanyWithSic: React.FC<Props> = ({ placeholder, sicCodes, setFormData }) => {
  const history = useNavigate();
  const [searchKey, setSearchKey] = useState("");
  const [selectedCompanyID, setSelectedCompanyID] = useState<string>("");
  const debouncedSearch = useDebouncedValue(searchKey);

  const queryObj = useMemo(() => ({ searchKey: debouncedSearch, sicCodes }), [debouncedSearch, sicCodes]);

  const connection = useQuery({
    ...companySearchWithSicQuery(queryObj),
    enabled: !!sicCodes?.length, 
	  });

  const configNameList = connection.isSuccess && connection.data;

  const addCompanyIdAtUrl = (value: CompanySearch) => {
    history(
      formatLocation.configurationCreate({
        companyID: value.companyID,
      })
    );
  };

  return (
    <Box mr={1}>
      <SelectConfig
        inputProps={{
          round: true,
          placeholder: placeholder,
        }}
        closeOnSelect
        onQueryChange={setSearchKey}
        items={configNameList || []}
        noResults={
          connection.isLoading ? (
            <InlineSpinnerIcon />
          ) : (
            <MenuItem disabled text="No results" />
          )
        }
        onItemSelect={(value: CompanySearch) =>{
          setSelectedCompanyID(value.companyID);
					addCompanyIdAtUrl(value)
        }}
        itemRenderer={(item, itemProps) => (
          <MenuItem
            key={item.companyID}
            active={itemProps.modifiers.active}
            text={item.name}
            onClick={itemProps.handleClick}
          />
        )}
        inputValueRenderer={(value) => value.name}
        popoverProps={{ minimal: true }}
      />
    </Box>
  );
};

export default SearchCompanyWithSic;
